export default "__VITE_ASSET__DAAH8uvY__"